import React from 'react';
import styled from 'styled-components';

import NoFilteredResults from 'src/components/NoFilteredResults';
import type { PageDependedProps } from 'src/components/NoFilteredResults/NoFilteredResults';
import type { IDeparture } from './DepartureList';
import { DepartureList } from './DepartureList';

interface Props extends PageDependedProps {
  linkedDepartures: IDeparture[] | null;
  isMobile?: boolean;
}

const EmptyHotels = ({
  linkedDepartures,
  isMobile = false,
  activeFilters,
  changeFilter,
  clearFilters,
  isMapExpanded,
}: Props) => (
  <StyledContainer $isMobile={isMobile}>
    <NoFilteredResults
      activeFilters={activeFilters}
      changeFilter={changeFilter}
      clearFilters={clearFilters}
      isMapExpanded={isMapExpanded}
    />
    {Array.isArray(linkedDepartures) && linkedDepartures.length ? (
      <LinkedDepartures
        linkedDepartures={linkedDepartures}
        isMobile={isMobile}
      />
    ) : null}
  </StyledContainer>
);

interface LinkedDeparturesProps {
  linkedDepartures: IDeparture[];
  isMobile: boolean;
}

const LinkedDepartures = ({
  linkedDepartures,
  isMobile,
}: LinkedDeparturesProps) => {
  const { length } = linkedDepartures;

  // Делим на два столбца
  const halfLength = length % 2 === 0 ? length / 2 : length / 2 + 1;
  const deps1 = linkedDepartures?.slice(0, halfLength);
  const deps2 = linkedDepartures?.slice(halfLength, length);

  return (
    <StyledWrapper $isMobile={isMobile}>
      <DepartureList departureList={deps1} />
      <DepartureList departureList={deps2} />
    </StyledWrapper>
  );
};

const StyledContainer = styled.div<{ $isMobile: boolean }>`
  width: 100%;

  ${({ $isMobile }) => ($isMobile ? `margin-left: 0; margin-top: 24px;` : '')}
`;

const StyledWrapper = styled.div<{ $isMobile: boolean }>`
  border-radius: 4px;
  margin-top: 24px;
  background-color: #fff;
  display: flex;
  padding: 16px;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  justify-content: center;
`;

export default EmptyHotels;
